module.exports = __webpack_public_path__ + "img/mp3.4dabe068.svg";